export const APP_NAME = 'Redhorse Technologies'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const REF_URL_KEY = 'ref'
